export const REGIONS = [
  {
    name: "Hà Nội",
    shops: [
      {
        name: "Thế giới sữa bỉm 5 sao Baby",
        addr: "Hà đông, TP Hà Nội",
      },
      {
        name: "Anh Ngọc Store",
        addr: "Mễ Trì, Nam Từ Liêm, Hà Nội",
      },
      {
        name: "Nhị Thực Baby",
        addr: "Thạch Thất, Hà Nội",
      },
      {
        name: "Sữa bỉm Uyên Nhi",
        addr: "Chương Mỹ, Hà Nội",
      },
      {
        name: "Sữa bỉm Hương Giang",
        addr: "Đông Anh, Hà Nội",
      },
      {
        name: "Lan Phương Shop",
        addr: "Ba Đình, Hà Nội",
      },
      {
        name: "Hàng Auth Đảo Sơ sinh",
        addr: "Đan Phượng, Hà Nội",
      },
      {
        name: "Sữa bỉm Tiến Phong",
        addr: "Phúc Thịnh, Hà Nội",
      },
      {
        name: "Moon mommy & baby",
        addr: "Phú Xuyên, Hà Nội",
      },
      {
        name: "sữa bỉm bình nguyệt",
        addr: "Sóc Sơn, Hà Nội",
      },
      {
        name: "Spa Baby & Float Trang Thu",
        addr: "Sơn Tây, Hà Nội",
      },
    ],
  },
  {
    name: "Hải Phòng",
    shops: [
      {
        name: "Bé Cưng plaza",
        addr: "An Đồng, Hải Phòng",
      },
      {
        name: "Yên Quý Mart",
        addr: "Thủy Nguyên, Hải Phòng",
      },
    ],
  },
  {
    name: "Vĩnh Phúc",
    shops: [
      {
        name: "Thế giới sữa cho mẹ và bé TT Milk",
        addr: "Phường Trưng Trắc, Vĩnh Yên",
      },
      {
        name: "Shop Hùng Thành",
        addr: "Phúc Yên, Vĩnh Phúc",
      },
      {
        name: "Ola Baby",
        addr: "Vĩnh Yên, Vĩnh Phúc",
      },
      {
        name: "Sữa bỉm Ngọc Lan",
        addr: "Vĩnh Yên, Vĩnh Phúc",
      },
      {
        name: "hệ thống Sữa Hoàng Yến",
        addr: "TT Thanh Lãng, Vĩnh Phúc",
      },
      {
        name: "Shop mẹ và bé Gấu Baby",
        addr: "Yên Lạc - Vĩnh Phúc",
      },
      {
        name: "Mẹ và bé Đậu Đậu store",
        addr: "Vĩnh Tưởng, Vĩnh Phúc",
      },
      {
        name: "Banana Baby",
        addr: "Vĩnh Tưởng, Vĩnh Phúc",
      },
      {
        name: "Hệ thống cửa hàng mẹ & bé Bao My Baby Shop",
        addr: "Phúc Yên, Vĩnh Phúc",
      },
      {
        name: "Siêu thị mẹ & bé Thanh Hoà",
        addr: "Cao Phong, Vĩnh Phúc",
      },
      {
        name: "Bảo My Baby Shop",
        addr: "Phúc Yên, Vĩnh Phúc",
      },
    ],
  },
  {
    name: "Hưng Yên",
    shops: [
      {
        name: "Shop Quỳnh Nguyễn",
        addr: "Văn Giang, hưng Yên",
      },
      {
        name: "Sữa Bỉm Minh Ngọc",
        addr: "Kim Động, Hưng Yên",
      },
    ],
  },
  {
    name: "Hải Dương",
    shops: [
      {
        name: "Updating...",
        addr: "",
      },
    ],
  },
  // thêm khu vực tuỳ ý…
  {
    name: "Bắc Ninh",
    shops: [
      {
        name: "Updating...",
        addr: "",
      },
    ],
  },
  {
    name: "Bắc Giang",
    shops: [
      {
        name: "Liên Dũng Mart",
        addr: "Yên Dũng, Bắc Giang",
      },
      {
        name: "Sữa bỉm Quỳnh Hường",
        addr: "Hiệp Hòa, Bắc Giang",
      },
      {
        name: "Hoàng Hải Baby",
        addr: "Hiêp Hòa, Bắc Giang",
      },
      {
        name: "Sữa bỉm Gấu Bông",
        addr: "Lục Ngạn, Bắc Giang",
      },
      {
        name: "Mẹ & bé Thảo Hòa",
        addr: "Việt Yên, Bắc Giang",
      },
      {
        name: "Sữa bỉm Khánh Huyền",
        addr: "Việt Yên, Bắc Giang",
      },
      {
        name: "Siêu thị mẹ & bé Tú Anh",
        addr: "Việt Yên, Bắc Giang",
      },
      {
        name: "Shop Tôm Kids",
        addr: "Hiệp Hòa, Bắc Giang",
      },
      {
        name: "Sữa bỉm Bình Vân",
        addr: "Lạng Giang, Bắc Giang",
      },
      {
        name: "Sữa bỉm Chiến - Thảo",
        addr: "Tân Yên, Bắc Giang",
      },
    ],
  },
  {
    name: "Yên Bái",
    shops: [
      {
        name: "Mẹ và bé Thủy Quyền",
        addr: "Nghĩa Lộ, Yên Bái",
      },
      {
        name: "Thế giới sữa bỉm Thanh Nhàn",
        addr: "Luc Yên, Yên Bái",
      },
      {
        name: "Sữa  bỉm Công Hậu",
        addr: "Yên Bình, Yên Bái",
      },
      {
        name: "Thê giới bỉm sữa Hùng Hiến",
        addr: "Tỉnh Yên Bái",
      },
      {
        name: "Hoa Cương Baby",
        addr: "Văn Chấn, Yên Bái",
      },
      {
        name: "Quầy thuốc Đại Lịch",
        addr: "Văn Chấn, Yên Bái",
      },
      {
        name: "Mẹ & bé Ong Baby",
        addr: "Yên Ninh, TP Yên Bái",
      },
    ],
  },
  {
    name: "Phú Thọ",
    shops: [
      {
        name: "Sữa bỉm Đức Hương",
        addr: "Ninh Dân, Phú Thọ",
      },
      {
        name: "Tý Khoai Baby",
        addr: "Văn Lung, TX Phú Thọ",
      },
      {
        name: "Bông Kids",
        addr: "Hạ Hòa, Phú Thọ",
      },
      {
        name: "Sữa bỉm Ánh Nguyệt",
        addr: "Thanh Thuỷ, Phú Thọ",
      },
      {
        name: "Bỉm sữa Huy Bình",
        addr: "Xã Hiền Lương, Phú Thọ",
      },
    ],
  },
  {
    name: "Tuyên Quang",
    shops: [
      {
        name: "Quầy thuốc Thái Nụ",
        addr: "Chiêm Hóa, Tuyên Quang",
      },
      {
        name: "Sữa bỉm Hưng Hiền",
        addr: "Chiêm Hóa, Tuyên Quang",
      },
      {
        name: "Quầy thuốc Thanh Hằng",
        addr: "Chiêm Hóa, Tuyên Quang",
      },
      {
        name: "Sữa bỉm Quỳnh Trang",
        addr: "Hàm Yên, Tuyên Quang",
      },
      {
        name: "Shop Duy Ngân",
        addr: "TT Vĩnh Lộc, Tuyên Quang",
      },
      {
        name: "Hải Quyên Kids & Mom",
        addr: "Tỉnh Tuyên Quang",
      },
      {
        name: "Sữa bỉm Vũ Định",
        addr: "Hàm Yên, Tuyên Quang",
      },
      {
        name: "Sữa Hà Đô Hàm Yên",
        addr: "TT Tân Yên, Tuyên Quang",
      },
    ],
  },
  {
    name: "Thái Nguyên",
    shops: [
      {
        name: "Bỉm Thái Nguyên",
        addr: "Phường Quang Trung - TP Thái Nguyên",
      },
      {
        name: "Shop Mẹ Bắp",
        addr: "Phổi Yên, Thái Nguyên",
      },
      {
        name: "Hệ thống sữa bỉm Thanh Hải",
        addr: "Sông Công, Thái Nguyên",
      },
    ],
  },
  // thêm khu vực tuỳ ý…
  {
    name: "Sơn La",
    shops: [
      {
        name: "Hà Đô Baby Yên Châu",
        addr: "TT Yên Châu, Sơn La",
      },
      {
        name: "Hà Đô Baby Hát Lót",
        addr: "Mai Sơn, Sơn La",
      },
      {
        name: "Hà Đô Minh Thơm",
        addr: "TP sơn La",
      },
    ],
  },
  {
    name: "Điện Biên",
    shops: [
      {
        name: "Hà Đô Phương Chi",
        addr: "Tuần Giáo, Điện Biên",
      },
    ],
  },
  {
    name: "Nam Định",
    shops: [
      {
        name: "Bắp Shop",
        addr: "Ý Yên, Nam Định",
      },
      {
        name: "Thảo Baby",
        addr: "Ý Yên, Nam Định",
      },
      {
        name: "Thỏ Tây Baby",
        addr: "TP Nam Định",
      },
      {
        name: "Shop Sinh Hưởng",
        addr: "Hải Hậu, Nam Định",
      },
      {
        name: "Sữa bỉm Baby Mart Chợ Dần",
        addr: "Vụ Bản, Nam Định",
      },
      {
        name: "Thế Giới Sữa Thiên Ân",
        addr: "Nghĩa Hưng, Nam Định",
      },
      {
        name: "Baby Home",
        addr: "Nam Trực, Nam Định",
      },
    ],
  },
  {
    name: "Thái Bình",
    shops: [
      {
        name: "Siêu thị sữa An Nam",
        addr: " Kiến Xương, Thái Bình",
      },
      {
        name: "Thêu Huy Baby",
        addr: "Vũ Thư, Thái Bình",
      },
      {
        name: "Baby Mart Cầu Đen Nam Trung",
        addr: "Tiền Hải, Thái Bình",
      },
      {
        name: "Dinh Hội Baby Mart ",
        addr: "TP Thái Bình",
      },
      {
        name: "Việt Thu Mini Mart",
        addr: "Vũ Lạc, Thái Bình",
      },
    ],
  },

  {
    name: "Ninh Bình",
    shops: [
      {
        name: "Updating...",
        addr: "",
      },
    ],
  },
  // thêm khu vực tuỳ ý…
  {
    name: "Thanh Hóa",
    shops: [
      {
        name: "Mẹ & bé Bé Xồm",
        addr: "TX Nghi Sơn, Thanh Hóa",
      },
      {
        name: "Shop Hà Thắm",
        addr: "Thạch Thành, Thanh Hóa",
      },
      {
        name: "Huệ Như Babycare",
        addr: "Thiệu Hóa, Thanh Hóa",
      },
      {
        name: "Thế giới mẹ bỉm sữa Cherry House",
        addr: "TX Nghi Sơn, Thanh Hóa",
      },
    ],
  },
  {
    name: "Nghệ An",
    shops: [
      {
        name: "Bỉm Sữa Xanh",
        addr: "Quỳnh Lưu, Nghệ An",
      },
      {
        name: "Mẹ và bé Hưng Châu",
        addr: "Hưng Nguyên, Nghệ An",
      },
      {
        name: "Siêu thị Mẹ Bống",
        addr: "Hưng Nguyên, Nghệ An",
      },
    ],
  },
  {
    name: "Hà Tĩnh",
    shops: [
      {
        name: "Updating...",
        addr: "",
      },
    ],
  },
  {
    name: "Quảng Bình",
    shops: [
      {
        name: "Updating...",
        addr: "",
      },
    ],
  },
];
